<template>
    <div class="container-fluid">
        <div class="loading-state" v-if="loading">
            <ProgressSpinner fill="transparent" aria-label="Loading" />
        </div>
        <div class="row mb-5">
            <div class="col-12">
                <div class="card h-100 mt-3">
                    <div class="card-header mb-0">
                        <h5>{{ $t("content.gprinttk") }}</h5>
                    </div>
                    <div class="card-body pt-0">
                        <div class="row">
                            <div class="col-lg-3">
                                <label class="form-label ms-0">{{ $t("content.sdate") }}</label>
                                <VueDatePicker v-model="start_date" :format="format" auto-apply :teleport="true"
                                    :max-date="new Date()" :enable-time-picker="false" month-name-format="long"
                                    :clearable="false" :text-input="textInputOptions" fluid />
                            </div>

                            <div class="col-lg-3">
                                <label class="form-label ms-0">{{ $t("content.edate") }}</label>
                                <VueDatePicker v-model="end_date" :format="format" auto-apply :teleport="true"
                                    :max-date="new Date()" :enable-time-picker="false" month-name-format="long"
                                    :clearable="false" :text-input="textInputOptions" fluid />
                            </div>

                            <div class="col-lg-1">
                                <label class="form-label ms-0 png"></label>
                                <material-button id="searchBtn" color="primary" class="float-lg-start float-sm-end mb-3"
                                    :disabled="start_date > end_date" @click="getOnlineList">
                                    <i class="material-icons material-symbols-outlined">search</i>
                                    {{ $t("buttons.sear") }}
                                </material-button>
                            </div>
                            <div class="col-lg-1">
                                <label class="form-label ms-0 png"></label>
                                <material-button id="cancelBtn" color="danger" class="float-lg-start float-sm-end mb-3"
                                    @click="cancelBtn">
                                    <i class="material-icons material-symbols-outlined">close</i>
                                    {{ $t("buttons.canc") }}
                                </material-button>
                            </div>

                        </div>

                        <hr />

                        <div class="row no-gutters">
                            <div class="col-12 d-flex justify-content-end align-items-center">
                                 <div class="me-3">
                                    <material-button id="pdfBtn" color="dark" variant="outline"
                                        class="float-lg-start float-sm-end mb-0 me-2" :title="t('buttons.printp')"
                                        @click="ticketListGen()" :disabled="listdata.length === 0">
                                        <i class="material-icons material-symbols-outlined">print</i>
                                    </material-button>
                                 </div>
                                 <div class="me-3">
                                    <material-button id="excelBtn" color="secondary" variant="outline"
                                        cclass="float-lg-start float-sm-end mb-0 me-2" :title="t('buttons.printpb')"
                                        @click="backCoverListGen()" :disabled="listdata.length === 0">
                                        <i class="material-icons material-symbols-outlined">description</i>
                                    </material-button>
                                 </div>
                                 <div class="me-3">
                                    <material-button id="excelBtn" color="danger" variant="outline"
                                        cclass="float-lg-start float-sm-end mb-0 me-2" :title="t('content.printrepltk')"
                                        @click="replaceTicketListGen()" :disabled="listdata.length === 0">
                                        <i class="material-icons material-symbols-outlined">receipt</i>
                                    </material-button>
                                 </div>
                            </div>
                        </div>
                        <pre></pre>
                        <div class="row mt-3">
                            <div class="table-responsive">
                                <table class="table table-flush">
                                    <thead class="thead-light">
                                        <tr>
                                            <th class="text-sm font-weight-normal text-center">
                                                <material-checkbox v-model="allTk" :checked="allTk" @change="setAllTk()"
                                                    :disabled="listdata.length === 0">
                                                </material-checkbox>
                                            </th>
                                            <th>#</th>
                                            <th>{{ $t("content.amndatetime") }}</th>
                                            <th>{{ $t("content.tkOwner") }}</th>
                                            <th>{{ $t("content.amnticketold") }}</th>
                                            <th>{{ $t("content.ticketno") }}</th>
                                            <th>{{ $t("content.payside") }}</th>
                                            <th>{{ $t("content.amnbiz") }}</th>
                                            <th>{{ $t("content.amnweightvalall") }}</th>
                                            <th>{{ $t("content.amnqtyunitall") }}</th>
                                            <th>{{ $t("content.amnpawnvalall") }}</th>
                                            <th>{{ $t("content.amnreceiveprofit") }}</th>
                                            <th>
                                                {{ $t("content.actpawn3") }} /
                                                {{ $t("content.actpawn4") }}
                                            </th>
                                            <th>{{ $t("content.spedis") }}</th>
                                            <th>{{ $t("content.gpay") }}</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(row, index) in listdata" :key="index"
                                            :class="[
                                                row.paySide == 'PAY' && row.migration ? 'bg-redeem'
                                                : row.paySide == 'PAY' && !row.migration ? 'bg-payment'
                                                : row.paySide === 'RECEIVE' && row.migration ? 'bg-reduce-cap'
                                                : row.paySide === 'RECEIVE' && !row.migration ? 'bg-receive'
                                                : row.paySide === 'NONE' && row.migration ? 'bg-nonemi' : 'bg-none',
                                                
                                                { 'font-bold': isNotPrinted(row.refNumber) }
                                            ]"
                                        >
                                            <td class="text-sm font-weight-normal text-center">
                                                <material-checkbox v-model="row.chk" :checked="row.chk"
                                                    @change="setTk(row)">
                                                </material-checkbox>
                                            </td>
                                            <td class="text-sm font-weight-normal">
                                                {{ formatNumberString((currentPage - 1) * perPage + index + 1) }}
                                            </td>
                                            <td class="text-sm font-weight-normal">
                                                {{ format_datetime(row.createDate) }}
                                            </td>
                                            <td class="text-sm font-weight-normal">
                                                {{ row.tkCusName }}
                                            </td>
                                            <td class="text-sm font-weight-normal">{{ row.prevRefNumber }}</td>
                                            <td class="text-sm font-weight-normal">
                                                {{ row.refNumber }}
                                            </td>
                                            <td class="text-sm font-weight-normal">
                                                {{ checkPaySide(row.paySide) }}
                                            </td>
                                            <td class="text-sm font-weight-normal">
                                                <span v-if="row.represent">
                                                    <span v-if="row.migration">
                                                        {{ checkTransaction(row.type) }} ({{
                                                            checkTransaction(row.migrationType) }},ทำแทน)
                                                    </span>
                                                    <span v-else>
                                                        {{ checkTransaction(row.type) }} (ทำแทน)
                                                    </span>
                                                </span>
                                                <span v-else-if="row.shopRepresent">
                                                    <span v-if="row.migration">
                                                        {{ checkTransaction(row.type) }} ({{
                                                            checkTransaction(row.migrationType) }},ออนไลน์)
                                                    </span>
                                                    <span v-else>
                                                        {{ checkTransaction(row.type) }} (ออนไลน์)
                                                    </span>
                                                </span>
                                                <span v-else-if="row.changeName">
                                                    <span v-if="row.migration">
                                                        {{ checkTransaction(row.type) }} ({{
                                                            checkTransaction(row.migrationType)
                                                        }},เปลี่ยนชื่อ)
                                                    </span>
                                                    <span v-else>
                                                        {{ checkTransaction(row.type) }} (เปลี่ยนชื่อ)
                                                    </span>
                                                </span>
                                                <span v-else>
                                                    <span v-if="row.migration">
                                                        {{ checkTransaction(row.type) }} ({{
                                                            checkTransaction(row.migrationType) }})
                                                    </span>
                                                    <span v-else>
                                                        {{ checkTransaction(row.type) }}
                                                    </span>
                                                </span>
                                            </td>
                                            <td class="text-sm font-weight-normal">{{
                                                formatNumberDecimalString(row.weight) }}
                                            </td>
                                            <td class="text-sm font-weight-normal">{{
                                                formatNumberDecimalString(row.quantity) }}
                                            </td>
                                            <td class="text-sm font-weight-normal">
                                                {{ formatNumberDecimalString(row.pawnValue) }}
                                            </td>

                                            <td class="text-sm font-weight-normal">{{
                                                formatNumberDecimalString(row.roundInterest) }}
                                            </td>
                                            <td class="text-sm font-weight-normal">
                                                {{ formatNumberDecimalString(row.diffValue) }}
                                            </td>
                                            <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.calDiscount) }}</td>
                                            <td class="text-sm font-weight-normal">
                                                <span
                                                v-if="row.type === 'DEC_PRINCIPLE' || row.type === 'INC_PRINCIPLE' || row.type === 'REDEEM'">
                                                <span v-if="row.payOrReceive === row.roundInterest" style="color:blue">
                                                    {{ formatNumberDecimalString(row.payOrReceive) }}
                                                </span>
                                                <span v-else>
                                                    <span v-if="row.paySide === 'PAY'" style="color:red">
                                                    {{ formatNumberDecimalString(row.payOrReceive) }}
                                                    </span>
                                                    <span v-else-if="row.paySide === 'RECEIVE'" style="color:green">
                                                    {{ formatNumberDecimalString(row.payOrReceive) }}
                                                    </span>
                                                    <span v-else>
                                                    {{ formatNumberDecimalString(row.payOrReceive) }}
                                                    </span>
                                                </span>
                                                </span>
                                                <span v-else-if="row.type === 'INTEREST'">
                                                <span v-if="row.payOrReceive !== row.roundInterest" style="color:blue">
                                                    {{ formatNumberDecimalString(row.payOrReceive) }}
                                                </span>
                                                <span v-else>
                                                    <span v-if="row.paySide === 'PAY'" style="color:red">
                                                    {{ formatNumberDecimalString(row.payOrReceive) }}
                                                    </span>
                                                    <span v-else-if="row.paySide === 'RECEIVE'" style="color:green">
                                                    {{ formatNumberDecimalString(row.payOrReceive) }}
                                                    </span>
                                                    <span v-else>
                                                    {{ formatNumberDecimalString(row.payOrReceive) }}
                                                    </span>
                                                </span>
                                                </span>
                                                <span v-else>
                                                <span v-if="row.paySide === 'PAY'" style="color:red">
                                                    {{ formatNumberDecimalString(row.payOrReceive) }}
                                                </span>
                                                <span v-else-if="row.paySide === 'RECEIVE'" style="color:green">
                                                    {{ formatNumberDecimalString(row.payOrReceive) }}
                                                </span>
                                                <span v-else>
                                                    {{ formatNumberDecimalString(row.payOrReceive) }}
                                                </span>
                                                </span>
                                            </td>
                                            <td class="text-sm font-weight-normal">
                                                <material-button color="info" variant="outline" class="rounded-circle"
                                                    :title="t('buttons.seed')" @click="openDetail(row)">
                                                    <i class="material-icons material-symbols-outlined">visibility</i>
                                                </material-button>
                                                <material-button color="info" variant="outline" class="rounded-circle"
                                                    v-show="false" data-bs-toggle="modal" data-bs-target="#lookupModal2"
                                                    id="detailModal">
                                                </material-button>
                                                <material-button color="dark" variant="outline" class="rounded-circle"
                                                    :title="t('buttons.printp')" @click="ticketGen(row)"
                                                    :disabled="row.type === 'REDEEM' || row.status === 'TERMINATE'">
                                                    <i class="material-icons material-symbols-outlined">print</i>
                                                </material-button>
                                                <material-button color="secondary" variant="outline"
                                                    class="rounded-circle" data-bs-toggle="tooltip"
                                                    data-bs-placement="top" :title="t('buttons.printpb')"
                                                    @click="backCoverGen(row)"
                                                    :disabled="row.type === 'PAWN' || row.status === 'TERMINATE'">
                                                    <i class="material-icons material-symbols-outlined">description</i>
                                                </material-button>
                                                <material-button color="danger" variant="outline" class="rounded-circle"
                                                    data-bs-toggle="tooltip" data-bs-placement="top" :title="t('content.printrepltk')"
                                                    :disabled="row.prevDeposit || row.prevWithdrawBySys || row.status === 'TERMINATE'" @click="replaceTicketGen(row)">
                                                    <i class="material-icons material-symbols-outlined">receipt</i>
                                                </material-button>
                                            </td>
                                        </tr>
                                        <tr v-if="listdata.length === 0">
                                            <td colspan="16" class="text-sm font-weight-normal">
                                                <p style="text-align: center">No Record Found</p>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td colspan="16" style="text-align: right">Total Rows : {{ totalRows_s }}
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                        <pre></pre>
                        <div style="display: flex; justify-content: flex-end">
                            <ul v-show="listdata.length > 0" class="pagination justify-content-end">
                                <div class="project-container">
                                    <div class="example-one">
                                        <vue-awesome-paginate v-model="currentPage" :total-items="totalRows"
                                            :items-per-page="perPage" @click="onClickHandler" />
                                    </div>
                                </div>
                            </ul>
                        </div>
                    </div>

                    <!-- Detail Modal -->
                    <TicketDetailModal 
                    v-if="workcaseDetail !== null"
                    :workcaseDetail="workcaseDetail"
                    :images="images"
                    :listinfo="listinfo"
                    :paymentE="paymentE"
                    :paymentL="payment_l"
                    :promotionDetail="promotionDetail"
                    :depRef="dep_ref"
                    :tkStatus="tk_status"
                    :intCal="int_cal"
                    :intPeriod="int_period"
                    :transactionLabel="checkTransaction(workcaseDetail.transactionType)"
                    :history="'no'" 
                    v-model:fcusdt="fcusdt" 
                    :afChangename=af_changename
                    :bfChangename=bf_changename
                    :transDatePrv=transdate_prv
                    @copy="copyBtn"
                    @openHistory="NewTab"/>
                    
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
/* eslint-disable no-unused-vars */
import ProgressSpinner from 'primevue/progressspinner';
import { reactive, ref, computed, onMounted, inject, onUpdated, nextTick , onUnmounted} from "vue";
import { useI18n } from "vue-i18n";
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import ExampleFive from "@/examples/ExampleOne";
import MaterialButton from "@/components/MaterialButton.vue";
import { VueImageZoomer } from 'vue-image-zoomer'
import 'vue-image-zoomer/dist/style.css';
import MaterialCheckbox from "@/components/MaterialCheckbox.vue";
import TicketDetailModal from '@/components/TicketDetailModal.vue';

import axios from "axios";
import * as st from "@/config/setting.js";
import moment from 'moment'
import noImg from "@/assets/img/noimg.png"

import { useWorkCaseStore } from '@/stores/workcase'
import { useCashAccountStore } from '@/stores/cashaccount'
import { useInterestStore } from '@/stores/interest'
import { usePaymentGroupStore } from '@/stores/paymentgroup'
import { useDepositStore } from '@/stores/deposit'


const storewc = useWorkCaseStore()
const storeca = useCashAccountStore()
const storei = useInterestStore()
const storepay = usePaymentGroupStore()
const storedepo = useDepositStore()

const { t } = useI18n();
const swal = inject("$swal");

const shop_detail = ref(null)
const listdata = ref([])
const start_date = ref(new Date(new Date().setHours(0, 0, 0)));
const end_date = ref(new Date(new Date().setHours(23, 59, 59)));
const currentPage = ref(1);
const totalRows = ref(1);
const perPage = ref(30);
const totalRows_s = ref();
const allTk = ref(false);

const workcaseDetail = ref(null);
const info_cat = ref('');
const int_cal = ref(0);
const tk_status = ref('');
const int_period = ref('');
const listinfo = ref([])
const images = ref([])
const images_l = ref([])
const payment_l = ref([])
const paymentE = ref('');
const loading = ref(false);
const dep_ref = ref('');
const promotionDetail = ref(null);
const fcusdt = ref(false)
const bf_changename = ref('');
const af_changename = ref('');
const transdate_prv = ref(null);

const listprintTK = ref(JSON.parse(localStorage.getItem("listprintTK")) || []);

const format = (date) => {
    return moment(String(date)).local().format('DD/MM/YYYY HH:mm');
}

const textInputOptions = {
    format: 'dd/MM/yyyy HH:mm'
};

const onClickHandler = () => {
    updatePagination()
};

const InfoFromSession = async (val) => {
    shop_detail.value = null
    const response = await storeca.cashaccountInfoFromSessionFetch();
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                shop_detail.value = response.data.data
                await getOnlineList()
            }
        }
    }
}

InfoFromSession()

function copyBtn() {
    navigator.clipboard.writeText(workcaseDetail.value.tkRefNumber);
}

const NewTab = async () => {
    sessionStorage.removeItem('deferWorkcaseUid');
    sessionStorage.setItem("deferWorkcaseUid", workcaseDetail.value.uid);
    if (sessionStorage.getItem('deferWorkcaseUid') !== null) {
        const win = window.open("#/generals/defer_items", "_blank");
        win.focus();
        sessionStorage.removeItem('deferWorkcaseUid');
    }
}

function format_datetime(value) {
    if (value) {
        return moment(String(value)).local().format('DD/MM/YYYY HH:mm:ss')
    }
}

function format_date(value) {
    if (value) {
        return moment(String(value)).local().format('DD/MM/YYYY')
    }
}


function formatNumberString(num) {
    return String(num).replace(
        /(\d)(?=(\d{3})+(?!\d))/g,
        "$1,"
    );
}

function formatNumberDecimalString(num) {
    if (num !== null && num !== undefined) {
        num = num.toFixed(2)
    } else {
        num = 0
        num = num.toFixed(2)
    }
    return String(num).replace(
        /(\d)(?=(\d{3})+(?!\d))/g,
        "$1,"
    );
}

const isNotPrinted = (refNumber) => {
    return !listprintTK.value.some(x => x.refNumber === refNumber);
};

// ⚠️ 3. ฟังก์ชันสำหรับเรียกใช้ตอนบันทึกข้อมูล (สำคัญมาก!)
// แทนที่จะเรียก localStorage.setItem ตรงๆ ให้ใช้ฟังก์ชันนี้สั่งเซฟแทน เพื่อให้หน้าจอเปลี่ยนตัวหนาทันที
const savePrintData = (item) => {
    // ตรวจสอบความซ้ำซ้อนก่อนเพิ่ม
    const isDuplicate = listprintTK.value.some((x) => x.refNumber === item.refNumber);
    
    if (!isDuplicate) {
        // เพิ่มข้อมูลลงในตัวแปรของ Vue (หน้าจอจะเปลี่ยนสถานะตัวหนาทันที)
        listprintTK.value.push({
            createDate: item.createDate,
            refNumber: item.refNumber
        });
        
        // บันทึกลงหน่วยความจำถาวร
        localStorage.setItem("listprintTK", JSON.stringify(listprintTK.value));
    }
};

// 4. ระบบดักจับการเปลี่ยนแปลงข้ามแท็บเบราว์เซอร์ (กรณีเปิดหลายหน้าจอพร้อมกัน)
const syncStorage = (event) => {
    if (event.key === 'listprintTK') {
        listprintTK.value = JSON.parse(event.newValue) || [];
    }
};

function cancelBtn() {
    start_date.value = new Date(new Date().setHours(0, 0, 0));
    end_date.value = new Date(new Date().setHours(23, 59, 59));
    listdata.value = [];
    allTk.value = false
    totalRows_s.value = ''
    currentPage.value = 1
    getOnlineList()
}

function checkTransaction(str) {
    // PAWN, INTEREST, REDEEM, INC_PRINCIPLE, DEC_PRINCIPLE
    let side = ''
    if (str === 'PAWN') {
        side = 'จำนำ'
    } else if (str === 'INTEREST') {
        side = 'ต่อดอกเบี้ย'
    } else if (str === 'REDEEM') {
        side = 'ไถ่ถอน'
    } else if (str === 'INC_PRINCIPLE') {
        side = 'เพิ่มต้น'
    } else if (str === 'DEC_PRINCIPLE') {
        side = 'ลดต้น'
    }
    return side
}

function checkPaySide(str) {
    // PAWN, INTEREST, REDEEM, INC_PRINCIPLE, DEC_PRINCIPLE

    let side = ''
    if (str === 'PAY') {
        side = 'จ่ายเงิน'
    } else if (str === 'RECEIVE') {
        side = 'รับเงิน'
    } else if (str === 'NONE') {
        side = 'ไม่มียอด'
    }
    return side
}

async function getOnlineList() {
    let data = "";
    data = {
        index: currentPage.value - 1,
        size: perPage.value,
        groupUid: shop_detail.value.groupUid,
        shopUid: shop_detail.value.uid,
        cusUid: '',
        refNumber: '',
        fromDate: moment(new Date(start_date.value)).format('YYYY-MM-DDTHH:mm:ss'),
        toDate: moment(new Date(end_date.value)).format('YYYY-MM-DDTHH:mm:59'),
        channel: 'LINE_LIFF', // SHOP, LINE_LIFF, MOB_ANDROID, MOB_IOS, WEB
        status: 'ACTIVE,FINISH', // ACTIVE,FINISH
    };
    const payload = data;
    // console.log("ld p : " + JSON.stringify(payload));
    const response = await storewc.workCaselistExFetch(payload);
    // console.log("ld r : " + JSON.stringify(response.data));
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                let listd = response.data.data.list;
                listd.map(function (x) {
                    x.chk = false;
                    return x
                });
                listdata.value = listd
                totalRows.value = response.data.data.ext.total
                totalRows_s.value = formatNumberString(totalRows.value)
            }
        }
    }
}

async function updatePagination() {
    listdata.value = [];
    let data = "";
    data = {
        index: currentPage.value - 1,
        size: perPage.value,
        groupUid: shop_detail.value.groupUid,
        shopUid: shop_detail.value.uid,
        cusUid: '',
        refNumber: '',
        fromDate: moment(new Date(start_date.value)).format('YYYY-MM-DDTHH:mm:ss'),
        toDate: moment(new Date(end_date.value)).format('YYYY-MM-DDTHH:mm:59'),
        channel: 'LINE_LIFF', // SHOP, LINE_LIFF, MOB_ANDROID, MOB_IOS, WEB
        status: 'ACTIVE,FINISH', // ACTIVE,FINISH
    };
    const payload = data;
    // console.log("ld p : " + JSON.stringify(payload));
    const response = await storewc.workCaselistExFetch(payload);
    // console.log("ld r : " + JSON.stringify(response.data));
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                let listd = response.data.data.list;
                listd.map(function (x) {
                    x.chk = false;
                    return x
                });
                listdata.value = listd
                totalRows.value = response.data.data.ext.total
                totalRows_s.value = formatNumberString(totalRows.value)
            }
        }
    }
}

async function openDetail(item) {
  workcaseDetail.value = null
  images.value = []
  images_l.value = []
  listinfo.value = []
  tk_status.value = ''
  int_cal.value = 0
  paymentE.value = ''
  int_period.value = ''
  fcusdt.value = false
  dep_ref.value = ''
  bf_changename.value = ''
  af_changename.value = ''
  transdate_prv.value = null
  promotionDetail.value = null

  await getworkCaseInfo(item.uid)
  if (workcaseDetail.value != null) {

    if (workcaseDetail.value.changeName ) {
      af_changename.value = item.cusName
       getworkCaseInfoPrv(workcaseDetail.value.prevRefNumber)
    }else { 
      if (workcaseDetail.value.transactionType !== 'PAWN') { 
          getworkCaseInfoPrv(workcaseDetail.value.prevRefNumber)
      }
    }

    if (workcaseDetail.value.deposit) {
      getDepositInfo(workcaseDetail.value.tkRefNumber)
    }
    detailPayment(workcaseDetail.value.paymentGroupUid)

    images_l.value = workcaseDetail.value.ticket.images
    listinfo.value = workcaseDetail.value.ticket.collaterals

    if (workcaseDetail.value.promotionUid !== '0') { 
          retrieveInfo(workcaseDetail.value)
    }

    if (workcaseDetail.value.transactionType !== 'REDEEM') {
      if(workcaseDetail.value.latest){
        calIntInt()
      }
      if (workcaseDetail.value.status === 'FINISH') {
        tk_status.value = 'ปกติ'
      } else if (workcaseDetail.value.status === 'FREEZE') {
        tk_status.value = 'อายัด'
      } else if (workcaseDetail.value.status === 'TERMINATE') {
        tk_status.value = 'ยกเลิก'
      } else if (workcaseDetail.value.status === 'ACTIVE') {
        tk_status.value = 'กำลังดำเนินการ'
      } else if (workcaseDetail.value.status === 'BREAKING') {
        tk_status.value = 'ของหลุด'
      }

    } else {
      if (workcaseDetail.value.status === 'FINISH') {
        tk_status.value = 'ไถ่ถอน'
      } else if (workcaseDetail.value.status === 'TERMINATE') {
        tk_status.value = 'ยกเลิก'
      }
    }
    if (images_l.value.length > 0) {
        getTicketImage()
        await nextTick();
        document.getElementById("detailModal").click();
    } else {
      let obj = {
        src: noImg,
        thumbnailImageSrc: noImg,
        alt: '',
        title: ''
      }
      images.value.push(obj)
      await nextTick();
      document.getElementById("detailModal").click();

    }
  }
}

async function getworkCaseInfo(id) {
    let data = "";
    data = {
        uid: id,
    };
    const payload = data;

    const response = await storewc.workCaseinfoFetch(payload);
    // console.log("workCaseInfo : " + JSON.stringify(response.data));
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                workcaseDetail.value = response.data.data
            }
        }
    }
}

async function calIntInt() {
    let postponeDate = ''
    if (workcaseDetail.value.postponeCount != 0) {
        postponeDate = moment(workcaseDetail.value.postponeDate).format('YYYY-MM-DD')
    }
    let data = "";
    let pawnValue = 0
    if (workcaseDetail.value.transactionType != 'REDEEM') {
        pawnValue = workcaseDetail.value.newPawnValue
    } else {
        pawnValue = workcaseDetail.value.pawnValue
    }
    let cusUid = workcaseDetail.value.customerInfo.customerUid
        
    if(workcaseDetail.value.represent || workcaseDetail.value.shopRepresent){
        cusUid =  workcaseDetail.value.tkCustomerInfo.customerUid 
    }

    data = {
        cusUid: cusUid,
        txType: workcaseDetail.value.transactionType,
        pawnDate: moment(workcaseDetail.value.workItems[0].startTime).format('YYYY-MM-DD'),
        previousTxDate: '',
        postponeDate: postponeDate,
        pawnValue: pawnValue,
        promotionUid: workcaseDetail.value.promotionUid,
        interestUid: workcaseDetail.value.interestUid,
    };
    const payload = data;
    // console.log("calIntInt p : " + JSON.stringify(payload));
    const response = await storei.interestCalculateFetch(payload);
    // console.log("calIntInt r : " + JSON.stringify(response.data));
    let res = ''
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                res = response.data.data
                int_cal.value = Number(res.overdueInterest) + Number(res.dueInterest)
                int_period.value = res.interestPeriod
            }
        }
    }
}

async function detailPayment(item) {
    // console.log('detailPayment : ' + item);
    let data = "";
    data = {
        uid: item,
    };
    const payload = data;
    const response = await storepay.paymentGroupinfoFetch(payload);

    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                paymentE.value = response.data.data
                filterPayType()
                // console.log('detailPayment : ' + JSON.stringify(paymentE.value));
            }
        }
    }
}

function filterPayType() {
    payment_l.value = []
    let pt = [{ name: 'CASH' },
    { name: 'BANK_TRANSFER' },
    { name: 'CREDIT_CARD' },
    { name: 'CHEQUE' },
    { name: 'PROMPT_PAY_MOBILE' },
    { name: 'PROMPT_PAY_TAX_ID' },
    { name: 'QR_CODE' },
    ]
    let lsum = []
    for (let i = 0; i < pt.length; i++) {
        lsum = filterSumPay(pt[i].name)
        if (lsum.length > 0) {
            payment_l.value.push({ name: pt[i].name, pay: lsum[0].pay, receive: lsum[0].receive, fee: lsum[0].fee })
        } else {
            payment_l.value.push({ name: pt[i].name, pay: 0, receive: 0, fee: 0 })
        }
    }
}

function filterSumPay(str) {
    let nump = 0, numr = 0, numf = 0
    let lp = paymentE.value.payments.filter((c) => c.type === str);
    if (lp.length > 0) {
        let pay = 0
        let receive = 0
        let fee = 0
        for (let i = 0; i < lp.length; i++) {
            pay = pay + lp[i].pay
            receive = receive + lp[i].receive
            fee = fee + lp[i].feeReceive
            // fee = fee + lp[i].fee
        }
        nump = pay
        numr = receive
        numf = fee
    }
    let lockL = []
    lockL.push({ pay: nump, receive: numr, fee: numf })
    // console.log('lockL : ' + JSON.stringify(lockL));
    return lockL
}

async function getTicketImage() {
    if (images.value.length === 0) {
        let url = []
        images.value = []
        for (let i = 0; i < images_l.value.length; i++) {
            if (images_l.value[i].imageUid !== "0") {
                url.push(String(st.url_api + "/doc-svc/document/info/" + images_l.value[i].imageUid));
            }
        }
        if (url.length > 0) {
            await getFile(url)
            if (images.value.length > 0) {
                // await nextTick();
                // document.getElementById("detailModal").click();

            } else {
                let obj = {
                    src: noImg,
                    thumbnailImageSrc: noImg,
                    alt: '',
                    title: ''
                }
                images.value.push(obj)
                // await nextTick();
                // document.getElementById("detailModal").click();
            }
        } else {
            let obj = {
                src: noImg,
                thumbnailImageSrc: noImg,
                alt: '',
                title: ''
            }
            images.value.push(obj)
            // await nextTick();
            // document.getElementById("detailModal").click();

        }
    } else {
        // await nextTick();
        // document.getElementById("detailModal").click();

    }
}

async function getFile(urls) {
    let file_L = []
    const key = JSON.parse(localStorage.getItem("FR-SDK-nvtx-boapp"));
    const accessToken = key.accessToken;
    axios.defaults.headers["Authorization"] = `Bearer ${accessToken}`;
    const requests = urls.map((url) => axios.get(url));
    await Promise.all(requests).then(allResults => {
        if (allResults) {
            file_L = allResults
            if (file_L !== null) {
                for (let i = 0; i < file_L.length; i++) {
                    // console.log('file_L : ' + JSON.stringify(file_L[i].data));
                    if (file_L[i].data.data !== null) {
                        const file = getFileFromBase64(file_L[i].data.data.data, file_L[i].data.data.name)
                        const data = URL.createObjectURL(file);
                        let obj = {
                            src: data,
                            thumbnailImageSrc: data,
                            alt: '',
                            title: ''
                        }
                        images.value.push(obj)
                    }
                }
            }
        }
    })
}


function getFileFromBase64(string64, fileName) {
    const trimmedString = string64.replace('dataimage/jpegbase64', '');
    const imageContent = atob(trimmedString);
    const buffer = new ArrayBuffer(imageContent.length);
    const view = new Uint8Array(buffer);

    for (let n = 0; n < imageContent.length; n++) {
        view[n] = imageContent.charCodeAt(n);
    }
    var ext = fileName.split('.').pop();
    let type = '';
    if (ext === 'jpg') {
        type = 'image/jpeg'
    } else if (ext === 'png') {
        type = 'image/png'
    }
    const blob = new Blob([buffer], { type });
    return new File([blob], fileName, { lastModified: new Date().getTime(), type });
}

async function setAllTk() {
    for (let i = 0; i < listdata.value.length; i++) {
        if (allTk.value) {
            listdata.value[i].chk = true
        } else {
            listdata.value[i].chk = false
        }
    }
}

async function setTk(item) {
    if (item.chk === false) {
        if (allTk.value) {
            allTk.value = false
        }
    } else if (item.chk === true) {
        let ck = true
        for (let i = 0; i < listdata.value.length; i++) {
            if (listdata.value[i].chk === false) {
                ck = false
                break
            }
        }
        if (ck) {
            allTk.value = true
        } else {
            allTk.value = false
        }
    }
}


async function ticketGen(item) {
    // 2. เช็กซ้ำโดยเจาะจงไปที่ฟิลด์ refNumber ภายใน Object
    const isDuplicate = listprintTK.value.some((x) => x.refNumber === item.refNumber);

    // 3. ถ้าไม่ซ้ำ ให้เก็บข้อมูลเป็น Object { createDate, refNumber } เข้าไป
    if (!isDuplicate) {
        listprintTK.value.push({
            createDate: item.createDate,
            refNumber: item.refNumber
        });
        // 4. บันทึกกลับลง LocalStorage
        localStorage.setItem("listprintTK", JSON.stringify(listprintTK.value));
    }
    let uids = []
    uids.push(item.uid)
    await getticketNew(uids)
}

async function backCoverGen(item) {
    let uids = []
    uids.push(item.uid)
    await getbackcoverNew(uids)
}

async function replaceTicketGen(item) {
    let uids = []
    uids.push(item.prevUid)
    await getreplaceTicketNew(uids)
}

async function ticketListGen() {
    let uids = []
    for (let i = 0; i < listdata.value.length; i++) {
        if (listdata.value[i].chk && listdata.value[i].status !== 'TERMINATE' && listdata.value[i].type !== 'REDEEM') {
            uids.push(listdata.value[i].uid)
        }
    }
    if (uids.length === 0) {
        swal("กรุณาเลือกรายการ", "", "warning");
        return
    } else {
                // 2. วนลูปเช็กข้อมูลจากตัวแปรของคุณ (สมมติว่าเป็น listdata.value)
        listdata.value.forEach(item => {
            // กรองเงื่อนไขตามที่คุณกำหนดไว้
            if (item.chk && item.status !== 'TERMINATE' && item.type !== 'REDEEM') {
                
                // 🔹 เติม .value หลัง listprintTK ในบรรทัดนี้
                const isDuplicate = listprintTK.value.some(storedItem => storedItem.refNumber === item.refNumber);

                if (!isDuplicate) {
                    // 🔹 เติม .value หลัง listprintTK ในบรรทัดนี้
                    listprintTK.value.push({
                        createDate: item.createDate,
                        refNumber: item.refNumber,
                    });
                }
            }
        });

        // 3. บันทึกกลับลง LocalStorage (🔹 เติม .value หลัง listprintTK ในบรรทัดนี้)
        localStorage.setItem("listprintTK", JSON.stringify(listprintTK.value));
    }
    await getticketNew(uids)

}

async function backCoverListGen() {
    let uids = []
    for (let i = 0; i < listdata.value.length; i++) {
        if (listdata.value[i].chk && listdata.value[i].status !== 'TERMINATE' && listdata.value[i].type !== 'PAWN') {
            uids.push(listdata.value[i].uid)
        }
    }
    if (uids.length === 0) {
        swal("กรุณาเลือกรายการ", "", "warning");
        return
    } else {
        await getbackcoverNew(uids)
    }
}

async function replaceTicketListGen() {
    let uids = []
    for (let i = 0; i < listdata.value.length; i++) {
        if (listdata.value[i].chk && listdata.value[i].status !== 'TERMINATE' && !(listdata.value[i].prevDeposit || listdata.value[i].prevWithdrawBySys)) {
            uids.push(listdata.value[i].prevUid)
        }
    }
    if (uids.length === 0) {
        swal("กรุณาเลือกรายการ", "", "warning");
        return
    } else {
        await getreplaceTicketNew(uids)
    }
}


async function getticketNew(id) {
    loading.value = true
    let data = {
        groupUid: shop_detail.value.groupUid,
        shopUid: shop_detail.value.uid,
        uids: id
    };
    const key = JSON.parse(localStorage.getItem("FR-SDK-nvtx-boapp"));
    const accessToken = key.accessToken;
    const response = await axios({
        method: 'POST',
        data: data,
        url: st.url_api + `/docgen-svc/ticket/pdf`,
        headers: { Authorization: `Bearer ${accessToken}` },
        responseType: 'arraybuffer',
    });
    loading.value = false
    if (response.headers.get("content-type") === 'application/pdf') {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank').focus();
    } else {
        swal("โหลด PDF ไม่สำเร็จ", "", "error");
    }
}

async function getbackcoverNew(id) {
    loading.value = true
    let data = {
        groupUid: shop_detail.value.groupUid,
        shopUid: shop_detail.value.uid,
        uids: id
    };
    const key = JSON.parse(localStorage.getItem("FR-SDK-nvtx-boapp"));
    const accessToken = key.accessToken;
    const response = await axios({
        method: 'POST',
        data: data,
        url: st.url_api + `/docgen-svc/backCover/pdf`,
        headers: { Authorization: `Bearer ${accessToken}` },
        responseType: 'arraybuffer',
    });
    loading.value = false
    if (response.headers.get("content-type") === 'application/pdf') {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank').focus();
    } else {
        swal("โหลด PDF ไม่สำเร็จ", "", "error");
    }
}


async function getreplaceTicketNew(id) {
  loading.value = true
  let data = {
    groupUid: shop_detail.value.groupUid,
    shopUid: shop_detail.value.uid,
    uids: id
  };
  const key = JSON.parse(localStorage.getItem("FR-SDK-nvtx-boapp"));
  const accessToken = key.accessToken;
  const response = await axios({
    method: 'POST',
    data: data,
    url: st.url_api + `/docgen-svc/ticket/replace/pdf`,
    headers: { Authorization: `Bearer ${accessToken}` },
    responseType: 'arraybuffer',
  });
  loading.value = false
  if (response.headers.get("content-type") === 'application/pdf') {
    const blob = new Blob([response.data], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank').focus();
  } else {
    swal("โหลด PDF ไม่สำเร็จ", "", "error");
  }
}

async function getDepositInfo(tkRef) {
    let data = "";
    data = {
        index: 0,
        size: 1,
        groupUid: shop_detail.value.groupUid,
        shopUid: shop_detail.value.uid,
        cusUid: '',
        refNumber: '',
        tkRefNumber: tkRef.trim(),
        channel: '',
        txDate: 0,
    };
    const payload = data;
    // console.log("ld p : " + JSON.stringify(payload));
    const response = await storedepo.listDepositFetch(payload);
    // console.log("ld r : " + JSON.stringify(response.data));
    if (response) {
        if (response.status === 200) {
            if (response.data.rtnDesc === "success") {
                let listd = response.data.data.list
                dep_ref.value = listd[0].refNumber
            }
        }
    }
}

async function getworkCaseInfoPrv(prevRefNumber) {
  let workcase_prv = null
  let data = "";
  data = {
    groupUid: shop_detail.value.groupUid,
    shopUid: shop_detail.value.uid,
    refNumber: prevRefNumber,
  };
  const payload = data;

  const response = await storewc.workCaseInfoByRefFetch(payload);
  //  console.log("workCaseInfoByRef : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        workcase_prv = response.data.data
        bf_changename.value = workcase_prv.tkCustomerInfo.name
        transdate_prv.value = workcase_prv.workItems[0].startTime 
      }
    }
  }
}

async function retrieveInfo(item) {
  promotionDetail.value = null
  let data = "";
  let pawnValue = 0
  if (item.transactionType != 'REDEEM') {
      pawnValue = item.newPawnValue
  } else {
      pawnValue = item.pawnValue
  }

  let cusUid = item.customerInfo.customerUid

  if(item.represent || item.shopRepresent){
     cusUid =  item.tkCustomerInfo.customerUid 
  }

  data = {
    cusUid : cusUid,
    pawnDate: moment(item.workItems[0].startTime).format('YYYY-MM-DD'),
    previousTxDate: '',
    pawnValue: pawnValue,
  };
  const payload = data;
  // console.log("calIntInt p : " + JSON.stringify(payload));
  const response = await storei.interestRetrieveFetch(payload);
  // console.log("retrieveInfo r : " + JSON.stringify(response.data));
  let res = ''
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        res = response.data.data
        const result = res.interests.flatMap(item => {
        // เงื่อนไข: เป็นโปรโมชัน และ periodMonths > 1
        if (item.promotion === true && item.periodMonths > 1) {
          // สร้าง Array ใหม่ที่มีจำนวน element เท่ากับ periodMonths และใส่ข้อมูล item ลงไป
          return Array.from({ length: item.periodMonths }, () => ({ ...item }));
        }
        // หากไม่ตรงเงื่อนไข ให้คืนค่าเดิมกลับไป 1 ชุด
        return [item];
        });
        // console.log('result : ' + JSON.stringify(result));
      res.interests  =  result
      promotionDetail.value = res
      // console.log('promotionDetail : ' + JSON.stringify(promotionDetail.value));
      }
    }
  }
}

onMounted(() => {
    window.addEventListener('storage', syncStorage);
});

onUnmounted(() => {
    window.removeEventListener('storage', syncStorage);
});

</script>
<style lang="scss" scoped>
.loading-state {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.3);
    z-index: 9999;
    display: flex;
    justify-content: center;
    align-items: center;
}
.font-bold {
    font-weight: 700 !important;
    color: #000000 !important; /* เปลี่ยนตัวหนังสือเป็นสีดำเพื่อให้ตัดกับพื้นหลังสีเขียวชัดเจน */
}
</style>